export interface IEndpoints {
  POST_REGISTER: string;
}

export enum ApiEndpoints {
  POST_REGISTER = "https://www.whisperies.com/mediatheques/api/register.json"
}
export enum DevApiEndpoints {
  POST_REGISTER = "https://dev.whisperies.com/mediatheques/api/register.json"
}



// WEBPACK FOOTER //
// ./src/api/endpoint.ts